<template>
  <SectionView class="diet" :title="title" :tips="tips">
    <p>{{content}}</p>
  </SectionView>
</template>

<script>
  import SectionView from "@/components/SectionView";

  /**
   * 文本卡片
   */
  export default {
    name: "TextCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 标题
      title: {
        type: String,
        default: '项目说明'
      },
      // 内容
      content: {
        type: String,
        require: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  p {
    margin-left: 20px;
    font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 28px;
color: #495880;
line-height: 44px;
text-align: justified;
font-style: normal;
text-transform: none;
  }
</style>